import React, { createContext, useContext } from 'react';

// Allows support for heading levels 1-9 via aria-level

var HeadingLevelContext = /*#__PURE__*/createContext(0);

/**
 * @internal
 * @returns The current heading level context.
 */
export var useHeadingElement = function useHeadingElement() {
  return useContext(HeadingLevelContext);
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injectes the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */
var HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  var parentHeadingLevel = useHeadingElement();
  var headingLevel = parentHeadingLevel + 1;
  return /*#__PURE__*/React.createElement(HeadingLevelContext.Provider, {
    value: value || headingLevel
  }, children);
};
export default HeadingLevelContextProvider;